import React from "react";
import ActivityIcon from "./ActivityIcon";

function sanitizeHtml(html) {
    // Use a shadow DOM to safely render HTML without DOMPurify dependency
    if (typeof document === "undefined") return "";
    try {
        const template = document.createElement("template");
        template.innerHTML = html || "";
        // Strip all script/iframe/object/embed elements
        const dangerous = template.content.querySelectorAll("script,iframe,object,embed,link,meta,base");
        dangerous.forEach((el) => el.remove());
        // Remove event handler attributes
        const all = template.content.querySelectorAll("*");
        all.forEach((el) => {
            for (const attr of [...el.attributes]) {
                if (attr.name.startsWith("on")) el.removeAttribute(attr.name);
            }
        });
        return template.innerHTML;
    } catch {
        return "";
    }
}

const fmtDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};

const ActivityTimeline = ({ activities, onEdit, onDelete, currentUserId, isSuperadmin }) => {
    if (!activities || activities.length === 0) {
        return <p className="crm-empty">No activities yet.</p>;
    }

    return (
        <div className="crm-activity-timeline">
            {activities.map((a) => {
                const canEdit = isSuperadmin || a.performedBy === currentUserId;
                const isHtml = a.body && (a.body.startsWith("<") || a.body.includes("</"));
                return (
                    <div key={a.id} className="crm-activity-item">
                        <ActivityIcon type={a.type} />
                        <div className="crm-activity-content">
                            <div className="crm-activity-subject">{a.subject}</div>
                            {a.body && (
                                isHtml ? (
                                    <div
                                        className="crm-activity-body"
                                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(a.body) }}
                                    />
                                ) : (
                                    <div className="crm-activity-body">{a.body}</div>
                                )
                            )}
                            {a.outcome && (
                                <div className="crm-activity-body" style={{ marginTop: 4, fontStyle: "italic" }}>
                                    Outcome: {a.outcome}
                                </div>
                            )}
                            <div className="crm-activity-meta">
                                <span>{a.type}</span>
                                <span>·</span>
                                <span>{a.performedByFirstName} {a.performedByLastName}</span>
                                <span>·</span>
                                <span>{fmtDate(a.createdAt)}</span>
                                {a.dueAt && <span>· Due: {fmtDate(a.dueAt)}</span>}
                                {a.type === "task" && (
                                    <span style={{ color: a.isDone ? "#10b981" : "#f59e0b" }}>
                                        · {a.isDone ? "Done" : "Pending"}
                                    </span>
                                )}
                            </div>
                        </div>
                        {canEdit && (
                            <div className="crm-activity-actions">
                                <button className="admin-btn admin-btn--sm" onClick={() => onEdit(a)}>Edit</button>
                                <button className="admin-btn admin-btn--sm admin-btn--danger" onClick={() => onDelete(a.id)}>Delete</button>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ActivityTimeline;
